module.exports = "/img/_/_/_/assets/images/card/type//damage.png?57c6e5bcaf30d515184699c7a883396d";